import axios from "axios";
import Vue from "vue";

// axios

// axios.defaults.headers.common["Authorization"] =
//   "Bearer " + localStorage.getItem("token");
// Production API by default; point a local server at it with VUE_APP_API_URL in
// client/.env.local (gitignored) instead of editing this line.
const axiosIns = axios.create({
	baseURL: process.env.VUE_APP_API_URL || "https://app.dikoturkiye.com/api",
	withCredentials: true,
	// timeout: 5000,
});
// axiosIns.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//   }
// );

Vue.prototype.$http = axiosIns;
export default axiosIns;
